import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getOwnerDocument } from '@flowio/browser-helpers';
import { safeInvoke } from '@flowio/react-helpers';
import React from 'react';
import ReactDOM from 'react-dom';
var initialState = {
  mounted: false
};

var Portal = /*#__PURE__*/function (_React$Component) {
  _inherits(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal(props) {
    var _this;

    _classCallCheck(this, Portal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "portalNode", void 0);

    _this.state = initialState;
    return _this;
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          className = _this$props.className,
          onMount = _this$props.onMount;
      this.portalNode = document.createElement('div');

      if (className != null) {
        this.portalNode.className = className;
      }

      var container = this.getContainerNode();

      if (container != null) {
        container.appendChild(this.portalNode);
      } // Force the component to re-render when mounted to render the React portal.


      this.setState({
        mounted: true
      });
      safeInvoke(onMount);
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps) {
      var nextClassName = nextProps.className;
      var previousClassName = this.props.className;

      if (nextClassName !== previousClassName) {
        if (this.portalNode != null) {
          if (nextClassName == null) {
            this.portalNode.className = '';
          } else {
            this.portalNode.className = nextClassName;
          }
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var onUnmount = this.props.onUnmount;
      safeInvoke(onUnmount);
      var container = this.getContainerNode();

      if (container != null && this.portalNode != null) {
        container.removeChild(this.portalNode);
      }
    }
    /**
     * Returns the DOM element where the children of this component are rendered.
     */

  }, {
    key: "getPortalNode",
    value: function getPortalNode() {
      return this.portalNode;
    }
    /**
     * Returns the DOM element where this component is appended.
     */

  }, {
    key: "getContainerNode",
    value: function getContainerNode() {
      var container = this.props.container;

      if (container == null) {
        // eslint-disable-next-line react/no-find-dom-node
        var node = ReactDOM.findDOMNode(this) || undefined;

        var _document = getOwnerDocument(node);

        return _document.body;
      }

      if (typeof container === 'function') {
        // eslint-disable-next-line react/no-find-dom-node
        return ReactDOM.findDOMNode(container());
      } // eslint-disable-next-line react/no-find-dom-node


      return ReactDOM.findDOMNode(container);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var mounted = this.state.mounted;

      if (!mounted) {
        return null;
      }

      if (this.portalNode == null) {
        return null;
      }

      var portal = /*#__PURE__*/ReactDOM.createPortal(children, this.portalNode);
      return portal;
    }
  }]);

  return Portal;
}(React.Component);

export default Portal;